const Card = ({ title, actions, children, className = '' }) => (
  <section className={`card ${className}`}>
    {(title || actions) && (
      <header className="card__header">
        {title ? <h2 className="card__title">{title}</h2> : <span />}
        {actions}
      </header>
    )}
    <div className="card__body">{children}</div>
  </section>
);

export default Card;
